interface ITopicMessageAction {
    topicId?: number | string;
    content?: string;
    referenceTopicMessageId?: number | string;
}

export interface ITopicMessage {
    id?: number;
    message?: string;
    displayName?: string;
    userType?: string;
    replyMessageId?: any;
    creationDate?: Date;
    deleted?: boolean;
}

export const newTopicMessage: ITopicMessage = {
    id: undefined,
    message: undefined,
    displayName: undefined,
    userType: undefined,
    replyMessageId: undefined,
    creationDate: undefined
}
